import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { "data-cy": "price-calories" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chooseSize = _resolveComponent("chooseSize")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_toppingFactory = _resolveComponent("toppingFactory")!
  const _component_instructionModal = _resolveComponent("instructionModal")!
  const _component_quantity = _resolveComponent("quantity")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_ctx.initialItem)
    ? (_openBlock(), _createBlock(_component_ion_card, {
        key: 0,
        class: "order-action"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, {
            class: _normalizeClass(["mx-0 mt-0 size-card", { 'd-none': _ctx.hideSizeDisplay }])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_content, { class: "topping-card-content ml-8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_chooseSize, {
                    menuItem: _ctx.initialItem,
                    onSize: _cache[0] || (_cache[0] = ($event: any) => (_ctx.size = $event)),
                    onCrust: _cache[1] || (_cache[1] = ($event: any) => (_ctx.crust = $event))
                  }, null, 8, ["menuItem"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_ion_card, { class: "mx-0 my-0 flex-fill-y" }, {
            default: _withCtx(() => [
              _createVNode(_component_toppingFactory, {
                initialItem: _ctx.initialItem,
                availableTopping: _ctx.availableTopping,
                selectedSize: _ctx.size,
                selectedRecipe: _ctx.crust,
                sauceCups: _ctx.sauceCups,
                class: "topping-factory topping-card-content",
                flavor: _ctx.flavor,
                "onUpdate:flavor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.flavor) = $event)),
                dressing: _ctx.dressings,
                "onUpdate:dressing": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dressings) = $event)),
                toppings: _ctx.toppings,
                "onUpdate:toppings": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.toppings) = $event)),
                defaultToppings: _ctx.defaultToppings,
                "onUpdate:defaultToppings": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.defaultToppings) = $event)),
                twoSidedItem: _ctx.twoSidedItem,
                "onUpdate:twoSidedItem": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.twoSidedItem) = $event)),
                onBlockSubmit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('blockSubmit', $event))),
                onLimit: _ctx.maxLimit,
                checkCount: ""
              }, null, 8, ["initialItem", "availableTopping", "selectedSize", "selectedRecipe", "sauceCups", "flavor", "dressing", "toppings", "defaultToppings", "twoSidedItem", "onLimit"]),
              (!_ctx.initialItem.isAddOn)
                ? (_openBlock(), _createBlock(_component_instructionModal, {
                    key: 0,
                    instructions: _ctx.instructions,
                    onUpdate: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('instructions', $event)))
                  }, null, 8, ["instructions"]))
                : _createCommentVNode("", true),
              (_ctx.quantity != undefined && _ctx.maxQuantity > 1)
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 1,
                    lines: "full",
                    "data-cy": "menu-item-quantity"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_quantity, {
                        modelValue: _ctx.quantity,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.quantity) = $event)),
                        limit: _ctx.maxQuantity,
                        lowerLimit: 1,
                        "should-show-error-toast": ""
                      }, null, 8, ["modelValue", "limit"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_row, { class: "ion-text-center ion-justify-content-center py-8 ion-padding-horizontal" }, {
                default: _withCtx(() => [
                  (_ctx.priceAndCal)
                    ? (_openBlock(), _createBlock(_component_ion_col, {
                        key: 0,
                        size: "6",
                        class: "py-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_1, [
                            (!_ctx.hidePrice)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "$" + _toDisplayString(_ctx.priceAndCal.itemPrice), 1))
                              : _createCommentVNode("", true),
                            (!_ctx.hidePrice && _ctx.priceAndCal.calories)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_3, " | "))
                              : _createCommentVNode("", true),
                            (_ctx.priceAndCal.calories)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.priceAndCal.calories), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createTextVNode(" " + _toDisplayString(_ctx.initialItem.isSalad ? 'Calories do not include dressing.' : ''), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "pt-0",
                    "data-cy": "calorie-description"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.isGiftCard)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "2,000 calories per day is used for general nutrition advice, but calorie needs may vary. Additional nutrition information is available upon request."))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "12",
                    class: "pt-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        innerHTML: _ctx.initialItem.itemAdditionalNutritionDescription
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}